import RequestDTO from '../RequestDTO';

export class AtCustByUserNumKeyRequestDTO extends RequestDTO {
  user_name: string;
  user_num_key: string;
  external_yn: 'Y' | 'N';

  constructor(user_name: string, user_num_key: string, external_yn: 'Y' | 'N') {
    super('NP_AT_CUST');
    this.user_name = user_name;
    this.user_num_key = user_num_key;
    this.external_yn = external_yn;
  }
}

export class AtCustByPhoneNumberRequestDTO extends RequestDTO {
  user_name: string;
  phone_number: string;
  external_yn: string;

  constructor(user_name: string, phone_number: string, external_yn: string) {
    super('NP_AT_CUST');
    this.user_name = user_name;
    this.phone_number = phone_number;
    this.external_yn = external_yn;
  }
}

export class AtPreJoinByUserNumKeyRequestDTO extends RequestDTO {
  user_name: string;
  user_num_key: string;

  constructor(user_name: string, user_num_key: string) {
    super('NP_AT_PREJOIN');
    this.user_name = user_name;
    this.user_num_key = user_num_key;
  }
}
